<template>
  <span>
    <template v-if="name === 'bell'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M473,375.5c-38.7-43.9-67-112.6-70.5-178.4C400.3,155.4,364.8,81.3,291.1,63c3.9-6.3,6.2-13.7,6.2-21.7
            c0-11.4-4.6-21.8-12.1-29.2C277.8,4.6,267.4,0,256,0s-21.8,4.6-29.2,12.1c-7.5,7.4-12.1,17.8-12.1,29.2c0,7.9,2.3,15.4,6.2,21.7
            c-73.7,18.3-109.2,92.4-111.4,134.1C106,262.9,77.7,331.6,39,375.5c-25.5,28.9,81.4,73.2,217,73.2S498.5,404.4,473,375.5z
            M263.3,48.6c-1.9,1.9-4.4,3-7.3,3c-2.9,0-5.4-1.1-7.3-3c-1.9-1.9-3-4.4-3-7.3c0-2.9,1.1-5.4,3-7.3c1.9-1.9,4.4-3,7.3-3
            s5.4,1.1,7.3,3s3,4.4,3,7.3C266.3,44.2,265.2,46.6,263.3,48.6z"
          />
          <path
            class="st0"
            d="M314.1,512c29.1,0,52.7-23.5,52.9-52.6c-33.5,6.1-69.9,9.6-104.9,9.9C267,493.6,288.4,512,314.1,512z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'birth'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <polygon class="st0" points="3.8,26.5 3.8,29.8 36.2,19.9 36.2,16.6" />
          <path
            class="st0"
            d="M3.8,35.1c0,0.5,0.3,1,0.7,1.4c0.4,0.3,1,0.4,1.5,0.3l29-9c0.7-0.2,1.2-0.9,1.2-1.6V24L3.8,34V35.1z"
          />
          <path class="st0" d="M12.3,29.6c0.2-1.1-0.9-1.7-0.9-1.7l-2.2,2.8C10.2,31.4,12.1,30.7,12.3,29.6z" />
          <path class="st0" d="M18.7,27.8c0.2-1.1-0.9-1.7-0.9-1.7l-2.2,2.8C16.6,29.6,18.5,28.9,18.7,27.8z" />
          <path class="st0" d="M25.1,26c0.2-1.1-0.9-1.7-0.9-1.7L22,27.1C22.9,27.8,24.9,27.1,25.1,26z" />
          <path class="st0" d="M31.5,24.2c0.2-1.1-0.9-1.7-0.9-1.7l-2.2,2.8C29.3,26,31.3,25.3,31.5,24.2z" />
          <path
            class="st0"
            d="M4.9,24.2l30.7-9.5c0.3-0.1,0.5-0.4,0.6-0.7c0-0.3-0.2-0.6-0.5-0.8l-7.5-2.8l0,0c0,4-2.2,6-6.7,6
        c-3.7,0-5.9-1.5-6.5-4.3L4,22.9c-0.3,0.3-0.3,0.7-0.1,1C4.1,24.2,4.5,24.4,4.9,24.2z"
          />
          <path
            class="st0"
            d="M21.5,14.9c2.4,0,5.1-0.5,5.1-4.4c0-4-3.1-7.3-5.1-7.3s-5.1,3.3-5.1,7.3C16.5,14.4,19.2,14.9,21.5,14.9z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'clock'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M20,1.3C9.7,1.3,1.3,9.7,1.3,20S9.7,38.7,20,38.7S38.7,30.3,38.7,20S30.3,1.3,20,1.3z M20,34.2
        c-7.8,0-14.2-6.4-14.2-14.2S12.2,5.8,20,5.8S34.2,12.2,34.2,20S27.8,34.2,20,34.2z"
          />
          <path
            class="st0"
            d="M20.2,9.8c-0.9,0-1.7,0.8-1.7,1.7v7.7l-5.4,5.4c-0.7,0.7-0.7,1.7,0,2.4c0.7,0.7,1.7,0.7,2.4,0l6.4-6.4v-1.7
        v-7.3C21.9,10.5,21.1,9.8,20.2,9.8z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'dictionary'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M511.4,238.2c-1.9-9-8.2-16.5-16.9-19.9l-30.2-11.7v31l5.7,2.2c2.6,1,4.5,3.2,5,6c0.6,2.7-0.3,5.5-2.2,7.5
        L279.1,447.1c-3.8,3.8-9.6,5-14.6,3.1L41.8,363.5C29.4,358.8,29.4,342,31,320.1c1.4-18.9,7.4-43.6,28.5-42.5l192.2,74.8
        c17.2,6.7,36.8,2.6,49.8-10.6l185.8-187c6.5-6.5,9.3-15.9,7.4-24.9s-8.2-16.5-16.8-19.8l-191-74.3c-17.2-6.7-36.8-2.6-49.8,10.6
        L21.6,263C4.6,277,0,303.1,0,326.3c0,23.2,1.5,51,27.8,61.9l-6.2-1.5l230,89.5c17.2,6.7,36.7,2.6,49.7-10.5L504,263.1
        C510.5,256.6,513.3,247.2,511.4,238.2z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'door'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M28.8,8.7C26.6,6.4,23.4,5,20,5s-6.6,1.4-8.8,3.7c-2.3,2.3-3.7,5.4-3.7,8.8V35h25v-1V17.5
        C32.5,14,31.1,10.9,28.8,8.7z M30.5,33h-21V17.5c0-2.9,1.2-5.5,3.1-7.4C14.5,8.1,17.1,7,20,7s5.5,1.2,7.4,3.1s3.1,4.5,3.1,7.4V33
        L30.5,33z"
          />
          <path
            class="st0"
            d="M14.8,19.8c-0.8,0-1.5,0.3-2.1,0.8c-0.5,0.5-0.9,1.3-0.9,2.1c0,0.8,0.3,1.5,0.9,2.1c0.5,0.5,1.3,0.8,2.1,0.8
        s1.5-0.3,2.1-0.8c0.5-0.5,0.8-1.3,0.8-2.1c0-0.8-0.3-1.5-0.8-2.1C16.4,20.1,15.6,19.8,14.8,19.8z M15.9,23.7
        c-0.3,0.3-0.7,0.4-1.1,0.4c-0.4,0-0.8-0.2-1.1-0.4c-0.3-0.3-0.4-0.7-0.4-1.1s0.2-0.8,0.4-1.1c0.3-0.3,0.7-0.4,1.1-0.4
        c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.1C16.4,23.1,16.2,23.5,15.9,23.7z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'draft'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M37.6,7.8l-5.4-5.4C30.8,1,28.5,1,27,2.4l-3.5,3.5l-17,17c-0.7,0.7-1.2,1.6-1.6,2.5L1.5,35
        c-0.4,1-0.1,2.1,0.6,2.9c0.8,0.8,1.9,1,2.9,0.6l9.6-3.4c0.9-0.3,1.8-0.9,2.5-1.6l16.1-16.1l0,0l0.9-0.9l3.5-3.5l0,0
        C39,11.5,39,9.2,37.6,7.8z M13.7,32.6l-6.1,2.2l-2.4-2.4l2.2-6.1c0,0,0-0.1,0.1-0.1l6.4,6.4C13.8,32.6,13.8,32.6,13.7,32.6z
        M15.3,31.7c-0.1,0.1-0.2,0.2-0.3,0.2L8.1,25c0.1-0.1,0.2-0.2,0.2-0.3L25.2,7.8l6.9,6.9L15.3,31.7z M35.8,11.2l-2.6,2.6l-0.1,0.1
        L26.2,7l2.7-2.7c0.4-0.4,1.1-0.4,1.6,0l5.4,5.4C36.2,10,36.2,10.7,35.8,11.2L35.8,11.2z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'earth'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M491.9,156.3c-19.5-46-51.9-85-92.7-112.6C358.3,16.1,309,0,256,0c-35.3,0-69,7.2-99.7,20.1
        c-45.9,19.5-85,51.9-112.6,92.7C16.1,153.7,0,203,0,256c0,35.3,7.2,69,20.1,99.7c19.5,46,51.9,85,92.7,112.6
        C153.7,495.9,203,512,256,512c35.3,0,69-7.2,99.6-20.1c46-19.5,85-51.9,112.6-92.7C495.9,358.3,512,309,512,256
        C512,220.7,504.8,187,491.9,156.3z M298.7,344.6c-9.9,14.1-2.1,35.3-13.7,47.5c-11.7,12.2-17.5,8.4-24.9,25.7
        c-0.9,2.2-13.6,30.7-17.3,21.7c3.3,8.2,0.3,15.9-9.3,15.9c-9.5,0,1.7,7.9-7.5,10.2c-2.7,0.7-3,6.3-1.9,13.5c-7-1-13.9-2.3-20.6-3.9
        c-9.3-29.1-14.4-63.5-14.4-72.6c-0.1-31.4-6.5-19-21.9-42.2c-10.5-15.7-19.5-32.7-19-51.9c-0.1,3.5,20.2-48.6,5.5-38.7
        c-17.8,12.1-21-16.7-38.2-19.2c-8.8-1.3-6.2-10.8-16.1-9.3c-8.9,1.4-19.1-7.8-25.9-12.7c-4.4-3.2-12.6-49-19.3-48.9
        c-9.5,0.1,7.4,32,3.9,32.7c-4.2,0.8-10.6-15.5-15.1-29.6c1.7-4.9,3.5-9.8,5.5-14.5c17.1-40.4,45.7-74.8,81.6-99.1
        c12.2-8.3,25.3-15.3,39.1-21.1c0.7,0,1.3-0.1,2-0.2c12.4-1.5,48.9-15.8,59.1-4.6c4.3,4.6-55.1,26.1-56.9,35.4c-1.1,6,14.6,5,16,5.1
        c15.9,1-4.6,16.8,5,19.6c14.6,3.9,29.1-62.1,40.2-28.5c4.6,13.6,24.1-10.3,25.4,6.5c1.4,17.5,17.4,21.9-12.4,26.7
        c-27.4,4.4-5.4,15.6-23.4,25c-17,8.9-31.8,13.1-43.8,29c-13.4,17.9-14.6,17.3-19.9,39.2c-2.9,11.9-17.2-8.1-11.6-15.7
        c-1.9,2.6-18.8-5.7-20.5-1.4c-3.3,8.3-12.2,3.8-19.2,8.8c-8.9,6.3-17.5,26.5-8.6,36c7.1,7.6,31.3-16.4,32.7-8.2
        c1,6.3-8.6,10.7-7.6,17c1.5,9.1,16.3-2.6,16.3,4.4c0,4.5-6,29.4,7.1,24.6c7.1-2.5,9,2.9,13.4,1.7c6.1-1.5,9.7-15.8,17-14.7
        c8.6,1.2,21.8,5.2,30.5,7.7c14.2,4.1,13.4,16.1,29.9,18.6c16.9,2.6,10.2,17.7,8.1,26.1C246.4,313.5,326.8,304.9,298.7,344.6z
        M392.3,125.9c0,0,14.9,0.2,18.1-0.3s3.1-7.9,3-9.5c0-1.6-8.6-5.4-6.5-6.5c2.1-1,7.4-2.5,9-3.6c0.7-0.5,2.6-2.1,4.5-3.8
        c6.5,7,12.6,14.3,18.2,22.1c-1,0.7-2.1,1.4-2.9,2.2c-2.1,2.1-8.5-0.6-8.5-0.6c-2.8,3-5.5,6-8.3,9c-1.4,3.2-2.7,6.4-4.1,9.6
        c0,0-9.5,4.7-13.8,5.2s-11.3-3.3-12.4-5C387.7,143,392.3,125.9,392.3,125.9z M463.5,343.7c-1.3,3.2-2.8,6.3-4.3,9.4
        c-1.5-4.7-3-8.9-4.3-11.1c-3.1-5.3-7.3-11.8-1.9-24.7c5.4-13-3-29.1-7.2-33.4s-4.2-7.6,0-14.1s-1-8.7-5.3-8.7
        c-4.2,0-7.4-7.6-12.7-6.5c-5.3,1.1-25.6,6.5-33.1,5.4s-31.2-24-31.3-29.4c0-5.5,1-26.1,3.1-29.4c2.2-3.2,13.9-18,18.2-24.5
        c4.2-6.5,10.6-15,15.9-16.1c5.4-1,29.8-5.1,37.1-7.1c7.4-2.1,6.4,1.9,8.5,6.2c1.4,0.2,2.8,0.4,4.2,0.6c0,0,5.8,1.1,9.5,3.9
        c0.8,0.6,1.6,1.1,2.4,1.6c12.1,27.6,18.8,58.1,18.8,90.2C481.2,287.1,474.9,316.7,463.5,343.7z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'fire'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M30.8,15.1c-1.7-2.6-2.8-4.4-4.7-8.8c0,0-1.4,1.8-2.4,4.4c-0.5-1.7-1.4-2.4-2.4-4.2c-1.4-2.3-1.6-5.2-1.6-5.2
        S17.5,2.6,16,5.8c-1.5,3.2-1.4,6.8-3,8.5c-0.6-3.4-2.2-4.3-2.2-4.3s-0.9,2.8-1.6,4.7c-1.7,3.4-2.7,6.7-2.7,10.4
        c0,3.7,1.5,7.1,4,9.6c2.5,2.5,5.8,4,9.6,4c3.7,0,7.1-1.5,9.6-4c2.5-2.5,4-5.8,4-9.6C33.6,21.4,32.3,17.6,30.8,15.1z M25.9,33.3
        c-1.6,1.6-3.7,2.4-5.9,2.4s-4.3-0.9-5.9-2.4c-1.6-1.6-2.4-3.7-2.4-5.9c0-0.8,0.1-1.5,0.2-2.3c0.4-1.8,1.1-4.3,1.1-4.3
        s1.8,1.6,2.1,2.7c0.6,1.8,1.4-1.1,2.1-2.8c0.6-0.7,1.4-3.1,1.8-4.6l4.4,7.9l3-3.7c0.9,1.7,1.9,4.4,1.9,7.1
        C28.3,29.6,27.4,31.7,25.9,33.3z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'gps'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M20,1.5c-7,0-12.7,5.7-12.7,12.7c0,1,0.2,2.1,0.5,3.2c0.6,1.9,1.5,4,2.6,6.1c3.3,6.3,8,12.8,8,12.8l1.5,2.2
        l1.5-2.2c0,0,2.7-3.8,5.5-8.4c1.4-2.3,2.8-4.8,3.8-7.1c0.5-1.2,1-2.3,1.3-3.4c0.3-1.1,0.5-2.1,0.5-3.2C32.7,7.2,27,1.5,20,1.5z
        M28.5,16.3c-0.5,1.5-1.3,3.5-2.4,5.4c-1.6,3-3.5,6.1-5,8.4c-0.4,0.6-0.8,1.2-1.1,1.7c-1.1-1.6-2.6-3.9-4-6.3
        c-1.3-2.2-2.5-4.5-3.4-6.5c-0.5-1-0.8-2-1.1-2.8c-0.2-0.8-0.4-1.5-0.4-2c0-2.5,1-4.7,2.6-6.3s3.8-2.6,6.3-2.6s4.7,1,6.3,2.6
        c1.6,1.6,2.6,3.8,2.6,6.3C28.9,14.7,28.8,15.4,28.5,16.3z"
          />
          <path
            class="st0"
            d="M20,10.1c-2.3,0-4.1,1.9-4.1,4.1c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1S22.3,10.1,20,10.1z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'home'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M392.9,6L123.3,66.9l0.9,1.7l-0.8-0.5L0,256.3l26.5,17.4l4.5-6.8v139.3L285.1,506l209.8-104.1V228.6l17.2-6.8
        L392.9,6z M270.3,466.2l-91.8-36.1V325.5l-62.9-18.6v98.5l-53.1-20.9v-166l78.2-119.2l120.2,221.9l3.9-1.5l5.4-2.1L270.3,466.2
        L270.3,466.2z M463.1,382.2L298.2,464V306.5l164.9-65.4V382.2z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'link'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M38.5,9.6c-0.2-1-0.5-1.9-1-2.8s-1.1-1.7-1.8-2.5c-1-1-2.1-1.7-3.4-2.2c-1.8-0.7-3.9-0.9-5.8-0.6
        c-1,0.2-1.9,0.5-2.8,1C22.8,3,22,3.6,21.3,4.3l-4.8,4.8c-1,1-1,2.6,0,3.5c1,1,2.6,1,3.5,0l4.8-4.8c0.5-0.5,1.1-0.9,1.7-1.1
        c0.9-0.4,2-0.5,3-0.3c0.5,0.1,1,0.3,1.4,0.5c0.5,0.2,0.9,0.5,1.3,0.9c0.5,0.5,0.9,1.1,1.1,1.7c0.4,0.9,0.5,2,0.3,3
        c-0.1,0.5-0.3,1-0.5,1.4c-0.2,0.5-0.5,0.9-0.9,1.3L27.3,20c-1,1-1,2.6,0,3.5c1,1,2.6,1,3.5,0l4.8-4.8c1-1,1.7-2.1,2.2-3.4
        C38.7,13.5,38.8,11.5,38.5,9.6z"
          />
          <path
            class="st0"
            d="M20,27.3l-4.8,4.8c-0.5,0.5-1.1,0.9-1.7,1.1c-0.9,0.4-2,0.5-3,0.3c-0.5-0.1-1-0.3-1.4-0.5
        c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5-0.5-0.9-1.1-1.1-1.7c-0.4-0.9-0.5-2-0.3-3c0.1-0.5,0.3-1,0.5-1.4c0.2-0.5,0.5-0.9,0.9-1.3l4.8-4.8
        c1-1,1-2.6,0-3.5c-1-1-2.6-1-3.5,0l-4.8,4.8c-1,1-1.7,2.1-2.2,3.4c-0.7,1.8-0.9,3.9-0.6,5.8c0.2,1,0.5,1.9,1,2.8
        c0.5,0.9,1.1,1.7,1.8,2.5c1,1,2.1,1.7,3.4,2.2c1.8,0.7,3.9,0.9,5.8,0.6c1-0.2,1.9-0.5,2.8-1s1.7-1.1,2.5-1.8l4.8-4.8
        c1-1,1-2.6,0-3.5C22.6,26.3,21,26.3,20,27.3z"
          />
          <path
            class="st0"
            d="M26.3,13.7c-1-1-2.6-1-3.5,0l-9.1,9.1c-1,1-1,2.6,0,3.5c1,1,2.6,1,3.5,0l9.1-9.1
        C27.3,16.3,27.3,14.7,26.3,13.7z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'logo'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 248 268"
        :width="width"
        :height="height"
        :style="styleObject"
      >
      <g>
        <polygon class="st0" fill="#231815" points="47.3,92.8 8.9,131.3 29.6,197.4 68.1,158.9"/>
        <polygon class="st0" fill="#231815" points="242.5,138.6 221.7,72.5 183.3,110.9 204.1,177.1"/>
        <polygon class="st1" points="133.6,6.5 54.4,85.7 75.2,151.8 154.4,72.6"/>
        <polygon class="st1" points="174.7,113.3 133.7,105.4 81.6,157.6 195.5,179.4 195.5,179.4"/>
        <polygon class="st1" points="120.2,174.1 97,197.3 117.7,263.4 193.1,188"/>
      </g>
      </svg>
    </template>
    <template v-if="name === 'parson'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M13.2,14c0.4,4.1,3,6.8,6.8,6.8c3.7,0,6.4-2.7,6.8-6.8l0.6-4.4c0.3-4.3-3.2-7.4-7.3-7.4s-7.7,3.1-7.3,7.4
        L13.2,14z"
          />
          <path
            class="st0"
            d="M34.4,31.6l-0.3-1.7c-0.2-1.4-1.1-2.7-2.4-3.3l-5.6-2.8c-0.2-0.1-0.3-0.2-0.4-0.4c-1.6,1.7-3.6,2.7-5.7,2.7
        s-4.1-1-5.7-2.7c-0.1,0.1-0.3,0.3-0.4,0.4l-5.6,2.8c-1.3,0.6-2.2,1.9-2.4,3.3l-0.3,1.7c-0.1,0.6,0,1.5,0.6,1.9
        c0.7,0.6,3.4,4.3,13.9,4.3s13.1-3.7,13.9-4.3C34.4,33.1,34.5,32.2,34.4,31.6z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'reply'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M22.6,13.8c-1.5,0-2.9,0-4.1,0V6.5L1.9,20l16.6,13.5v-8c0.5,0,1,0,1.5,0c6.8,0,16.1-0.2,16.8,7.1
        C40.3,24.7,37.4,13.8,22.6,13.8z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'save'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M19,24.2c0.3,0.3,0.6,0.5,1,0.5s0.7-0.2,0.9-0.5l6.9-8.7c0.3-0.3,0.3-0.7,0.2-0.9c-0.1-0.3-0.4-0.4-0.9-0.4
        h-2.6c-0.7,0-1.3-0.6-1.3-1.3V4.5c0-0.8-0.7-1.5-1.5-1.5h-3.4c-0.8,0-1.5,0.7-1.5,1.5v8.3c0,0.7-0.6,1.3-1.3,1.3h-2.6
        c-0.4,0-0.7,0.1-0.9,0.4c-0.1,0.3-0.1,0.6,0.2,0.9L19,24.2z"
          />
          <path
            class="st0"
            d="M38.7,27.6l-3.5-11.7H31l-2.1,3.7h2.6l2.3,7.9H6.2l2.3-7.9h2.6L9,15.9H4.8L1.3,27.6v7.5c0,1,0.8,1.9,1.9,1.9
        h33.6c1,0,1.9-0.8,1.9-1.9V31V27.6z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'setting'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M37.7,16.6l-4.1-0.2c-0.4,0-0.7-0.2-0.8-0.6l-0.8-2c-0.1-0.3-0.1-0.7,0.2-1l2.7-3c0.3-0.4,0.3-1,0-1.3
        l-3.4-3.4c-0.4-0.4-0.9-0.4-1.3,0l-3,2.7c-0.3,0.3-0.7,0.3-1,0.2l-2-0.8c-0.3-0.1-0.6-0.5-0.6-0.8l-0.2-4.1c0-0.5-0.4-0.9-1-0.9
        h-4.8c-0.5,0-0.9,0.4-1,0.9l-0.2,4.1c0,0.4-0.2,0.7-0.6,0.8l-2,0.8c-0.3,0.1-0.7,0.1-1-0.2l-3-2.7c-0.4-0.3-1-0.3-1.3,0L5.1,8.5
        c-0.4,0.4-0.4,0.9,0,1.3l2.7,3c0.3,0.3,0.3,0.7,0.2,1l-0.8,2c-0.1,0.3-0.5,0.6-0.8,0.6l-4.1,0.2c-0.5,0-0.9,0.4-0.9,1v4.8
        c0,0.5,0.4,0.9,0.9,1l4.1,0.2c0.4,0,0.7,0.2,0.8,0.6l0.8,2c0.1,0.3,0.1,0.7-0.2,1l-2.7,3c-0.3,0.4-0.3,1,0,1.3l3.4,3.4
        c0.4,0.4,0.9,0.4,1.3,0l3-2.7c0.3-0.3,0.7-0.3,1-0.2l2,0.8c0.3,0.1,0.6,0.5,0.6,0.8l0.2,4.1c0,0.5,0.4,0.9,1,0.9h4.8
        c0.5,0,0.9-0.4,1-0.9l0.2-4.1c0-0.4,0.2-0.7,0.6-0.8l2-0.8c0.3-0.1,0.7-0.1,1,0.2l3,2.7c0.4,0.3,1,0.3,1.3,0l3.4-3.4
        c0.4-0.4,0.4-0.9,0-1.3l-2.7-3c-0.3-0.3-0.3-0.7-0.2-1l0.8-2c0.1-0.3,0.5-0.6,0.8-0.6l4.1-0.2c0.5,0,0.9-0.4,0.9-1v-4.8
        C38.7,17.1,38.3,16.7,37.7,16.6z M20,26.1c-3.4,0-6.1-2.7-6.1-6.1s2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1S23.4,26.1,20,26.1z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'trash'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve"
        x="0px"
        y="0px"
        viewBox="0 0 40 40"
        :width="width"
        :height="height"
        :style="styleObject"
      >
        <g>
          <path
            class="st0"
            d="M7.8,35.2c0.2,2,1.8,3.4,3.8,3.4h16.9c2,0,3.6-1.5,3.8-3.4l1.9-24.5H5.9L7.8,35.2z M32,12.6L30.3,35
        c-0.1,1-0.9,1.7-1.9,1.7H11.6c-1,0-1.8-0.7-1.9-1.7L8,12.6H32z"
          />
          <path
            class="st0"
            d="M14.7,33.1c0.4,0,0.8-0.4,0.7-0.8l-0.7-14.7c0-0.4-0.4-0.8-0.8-0.7c-0.4,0-0.8,0.4-0.7,0.8l0.7,14.7
        C13.9,32.8,14.2,33.1,14.7,33.1z"
          />
          <path
            class="st0"
            d="M20,33.1c0.4,0,0.8-0.3,0.8-0.8V17.6c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v14.7
        C19.2,32.7,19.6,33.1,20,33.1z"
          />
          <path
            class="st0"
            d="M25.3,33.1c0.4,0,0.8-0.3,0.8-0.7l0.7-14.7c0-0.4-0.3-0.8-0.7-0.8c-0.4,0-0.8,0.3-0.8,0.7l-0.7,14.7
        C24.6,32.7,24.9,33,25.3,33.1z"
          />
          <path
            class="st0"
            d="M33.3,6c0,0-2.5-0.4-3.2-0.6c-0.6-0.2-5.9-1-5.9-1L24.1,3c-0.1-1-0.9-1.7-1.9-1.7H20h-2.2
        c-0.9,0-1.7,0.7-1.9,1.7l-0.2,1.4c0,0-5.3,0.8-5.9,1C9.1,5.6,6.6,6,6.6,6C5.9,6.2,5.4,7,5.4,7.8v1.6H20h14.6V7.8
        C34.6,7,34.1,6.2,33.3,6z M21.5,4.2h-3C18.3,4.2,18,4,18,3.7s0.2-0.5,0.5-0.5h3c0.3,0,0.5,0.2,0.5,0.5S21.7,4.2,21.5,4.2z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'arrow-left-double'">
      <svg
          version="1.1"
          id="_x32_"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          x="0px"
          y="0px"
          viewBox="0 0 40 40"
          :width="width"
          :height="height"
          :style="styleObject"
      >
        <g>
          <polygon
              class="st0"
              points="16.6,11.1 7.6,20.1 16.6,29.1 19.6,26.1 13.6,20.1 19.6,14.1 "
          />
          <path
              class="st0"
              d="M20,1.3C9.7,1.3,1.3,9.7,1.3,20c0,10.3,8.4,18.7,18.7,18.7c10.3,0,18.7-8.4,18.7-18.7
                 C38.7,9.7,30.3,1.3,20,1.3z M31.1,31.1c-2.9,2.8-6.8,4.6-11.1,4.6c-4.3,0-8.3-1.8-11.1-4.6C6,28.3,4.3,24.3,4.3,20
                 c0-4.3,1.8-8.3,4.6-11.1C11.7,6,15.7,4.3,20,4.3c4.3,0,8.3,1.8,11.1,4.6c2.8,2.9,4.6,6.8,4.6,11.1C35.7,24.3,34,28.3,31.1,31.1z"
          />
          <polygon
              class="st0"
              points="27.4,11.1 18.4,20.1 27.4,29.1 30.3,26.1 24.3,20.1 30.3,14.1 "
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'arrow-left-single'">
      <svg
          version="1.1"
          id="_x32_" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          x="0px"
          y="0px"
          viewBox="0 0 40 40"
          :width="width"
          :height="height"
          :style="styleObject"
      >
        <g>
          <polygon
              class="st0"
              points="21.6,11 12.6,20 21.6,29 24.6,26 18.6,20 24.6,14 "
          />
          <path
              class="st0"
              d="M20,1.3C9.7,1.3,1.3,9.7,1.3,20c0,10.3,8.4,18.7,18.7,18.7c10.3,0,18.7-8.4,18.7-18.7
                 C38.7,9.7,30.3,1.3,20,1.3z M31.1,31.1c-2.9,2.8-6.8,4.6-11.1,4.6c-4.3,0-8.3-1.8-11.1-4.6C6,28.3,4.3,24.3,4.3,20
                 c0-4.3,1.8-8.3,4.6-11.1C11.7,6,15.7,4.3,20,4.3c4.3,0,8.3,1.8,11.1,4.6c2.8,2.9,4.6,6.8,4.6,11.1C35.7,24.3,34,28.3,31.1,31.1z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'arrow-right-single'">
      <svg
          version="1.1"
          id="_x32_"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          x="0px"
          y="0px"
          viewBox="0 0 40 40"
          style="enable-background:new 0 0 40 40;"
          :width="width"
          :height="height"
          :style="styleObject"
      >
        <g>
          <polygon
              class="st0"
              points="15.4,14 21.4,20 15.4,26 18.4,29 27.4,20 18.4,11 "
          />
          <path
              class="st0"
              d="M20,1.3C9.7,1.3,1.3,9.7,1.3,20c0,10.3,8.4,18.7,18.7,18.7c10.3,0,18.7-8.4,18.7-18.7
             C38.7,9.7,30.3,1.3,20,1.3z M31.1,31.1c-2.9,2.8-6.8,4.6-11.1,4.6c-4.3,0-8.3-1.8-11.1-4.6C6,28.3,4.3,24.3,4.3,20
                 c0-4.3,1.8-8.3,4.6-11.1C11.7,6,15.7,4.3,20,4.3c4.3,0,8.3,1.8,11.1,4.6c2.8,2.9,4.6,6.8,4.6,11.1C35.7,24.3,34,28.3,31.1,31.1z"
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'arrow-right-double'">
      <svg
          version="1.1"
          id="_x32_"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          x="0px"
          y="0px"
          viewBox="0 0 40 40"
          style="enable-background:new 0 0 40 40;"
          :width="width"
          :height="height"
          :style="styleObject"
      >
        <g>
          <polygon
              class="st0"
              points="23.4,28.9 32.3,20 23.4,11 20.4,14 26.4,20 20.4,26"
          />
          <path
              class="st0"
              d="M20,38.7c10.3,0,18.7-8.4,18.7-18.7C38.6,9.8,30.3,1.4,20,1.4C9.6,1.4,1.3,9.8,1.3,20.1
                 C1.3,30.4,9.6,38.7,20,38.7z M8.8,8.9c2.9-2.8,6.8-4.6,11.1-4.6c4.3,0,8.3,1.8,11.1,4.6c2.8,2.9,4.6,6.8,4.6,11.1
                 c0,4.3-1.8,8.3-4.6,11.1c-2.9,2.8-6.8,4.6-11.1,4.6c-4.3,0-8.3-1.8-11.1-4.6C6,28.3,4.2,24.4,4.2,20.1C4.2,15.7,6,11.8,8.8,8.9z"
          />
          <polygon
              class="st0"
              points="12.6,28.9 21.6,20 12.6,11 9.6,14 15.6,20 9.6,26 "
          />
        </g>
      </svg>
    </template>
    <template v-if="name === 'click_hand'">
      <svg
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 30 20"
        style="enable-background:new 0 0 30 20;"
        xml:space="preserve"
        :width="width"
        :height="height"
        :style="styleObject">
      <g>
        <path class="st0" fill="#FFFFFF" d="M27.4,8.1c-0.2-0.6-0.6-1-1.1-1.4c-0.2-0.2-0.5-0.3-0.8-0.4c-0.3-0.1-0.6-0.2-0.9-0.2h-8.7
          c0.3-0.3,0.7-0.7,1.4-1.3c0.3-0.3,0.6-0.6,0.7-0.9c0.2-0.3,0.3-0.7,0.3-1c0-0.3-0.1-0.6-0.2-0.8c-0.2-0.5-0.6-0.9-1-1.2
          s-1-0.5-1.6-0.5c-0.6,0-1.1,0.2-1.5,0.5c-0.1,0-0.2,0.1-0.4,0.3c-0.7,0.5-2,1.3-3.3,2.2C9.3,4.1,8.1,4.9,7.3,5.4
          c-0.5-0.4-1-0.6-1.7-0.6H5.2c-0.7,0-1.4,0.3-1.9,0.8C2.8,6.1,2.5,6.8,2.5,7.5v7.6c0,0.7,0.3,1.4,0.8,1.9c0.5,0.5,1.1,0.8,1.9,0.8
          h0.4c0.6,0,1.1-0.2,1.6-0.6l5.5,1.8l0,0l0,0c0.5,0.2,1,0.2,1.4,0.2c1.8,0,3.4-1.1,4.1-2.7l1.8-4.3h4.4c0.9,0,1.6-0.4,2.2-0.9
          c0.6-0.6,0.9-1.3,0.9-2.2C27.7,8.9,27.6,8.5,27.4,8.1z M25.6,10.4c-0.3,0.3-0.7,0.4-1,0.4H20c-0.5,0-1,0.3-1.2,0.8L16.8,16
          c-0.2,0.6-0.6,1-1.1,1.3s-1,0.5-1.6,0.5c-0.3,0-0.6,0-0.9-0.2l0,0l-5.7-1.9v-4.9c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4v4.7
          H6.6l-0.1,0.2c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.1-0.5,0.1H5.2c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.3-0.5-0.3-0.8V7.6
          c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3h0.4c0.2,0,0.5,0.1,0.6,0.2C6.4,6.9,6.5,7,6.6,7.2l0.1,0.3h0.5l0.1-0.1
          c0,0,1.8-1.2,3.7-2.4c1-0.6,1.9-1.2,2.7-1.8c0.4-0.3,0.7-0.5,1-0.7c0.1-0.1,0.2-0.2,0.3-0.2s0.2-0.1,0.2-0.1
          c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0s0.3,0,0.4,0.1c0.2,0.1,0.4,0.2,0.5,0.4c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0,0.2,0,0.2
          c0,0.1,0,0.2-0.1,0.3c-0.1,0.1-0.2,0.3-0.4,0.4c-0.8,0.7-1.3,1.2-1.6,1.5c-0.3,0.3-0.4,0.4-0.4,0.4c-0.2,0.3-0.4,0.6-0.4,0.9
          c0,0.2,0,0.4,0.1,0.5c0.2,0.5,0.7,0.8,1.2,0.8h9.3c0.2,0,0.3,0,0.5,0.1c0.2,0.1,0.5,0.3,0.6,0.6C25.9,8.8,26,9,26,9.3
          C26,9.7,25.9,10.1,25.6,10.4z"/>
      </g>
      </svg>
    </template>
    <template v-if="name === 'step1'">
      <svg
      version="1.1"
      id="レイヤー_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 72.9 58"
      style="enable-background:new 0 0 72.9 58;"
      xml:space="preserve"
      :width="width"
      :height="height">
      <path class="st0" fill="none" stroke="#69BACA" stroke-miterlimit ="10" d="M65,44.4c3.9-4.4,6.1-9.7,6.1-15.5c0-15.1-15.7-27.4-35.1-27.4S1,13.7,1,28.9s15.7,27.4,35.1,27.4
        c8.6,0,16.5-2.4,22.6-6.5c0.7,0.2,1.6,0.3,2.5,0.5c8.4,1.8,10.6-3.1,10.6-3.1C68.3,47.3,66.2,45.7,65,44.4z"/>
      <g>
        <path class="st1" fill="#31507A" d="M12.5,18c-0.3,0-0.9,0-1.6,0.3c-1.1,0.6-1.2,1.5-0.9,2.1c0.4,0.8,1.1,1,2.4,0.9c1.6-0.1,2.6,0.3,3.2,1.4
          c0.6,1.3,0.2,2.8-1.6,3.6c-0.7,0.4-1.7,0.5-2.2,0.4l-0.1-0.9c0.6,0.1,1.3,0,2-0.4c1.1-0.5,1.5-1.4,1-2.3c-0.4-0.8-1.1-1.1-2.4-1
          c-1.5,0.1-2.7-0.2-3.2-1.3c-0.6-1.2,0-2.7,1.5-3.4c0.8-0.4,1.5-0.5,1.9-0.4L12.5,18z"/>
        <path class="st1" fill="#31507A" d="M14.9,17.1l0.7-0.7l0.7,1.4l1.5-0.7l0.3,0.7l-1.5,0.7l1.7,3.4c0.4,0.7,0.8,1,1.4,0.8c0.3-0.1,0.4-0.3,0.6-0.4
          l0.4,0.7c-0.2,0.2-0.4,0.4-0.8,0.6c-1.4,0.7-2.1-0.6-2.4-1.2l-1.6-3.4l-0.9,0.4l-0.3-0.7l0.9-0.4L14.9,17.1z"/>
        <path class="st1" fill="#31507A" d="M25.9,20.1c-0.3,0.3-0.8,0.8-1.7,1.3c-1.7,0.8-3.3,0.1-4.2-1.6c-0.9-1.8-0.5-3.7,1.1-4.4
          c1.8-0.9,3.1,0.6,3.6,1.6c0.1,0.2,0.2,0.4,0.2,0.5l-4,2c0.8,1.6,2,1.8,3.1,1.3c0.7-0.4,1.1-0.7,1.4-1.1L25.9,20.1z M23.7,17.1
          c-0.4-0.8-1.2-1.7-2.4-1.1c-1.1,0.5-1.1,1.8-0.7,2.6L23.7,17.1z"/>
        <path class="st1" fill="#31507A" d="M26.1,14.2c0.1-0.9,0.5-1.7,1.5-2.1c1.4-0.7,3,0,3.9,1.8c1.1,2.2,0.3,3.8-1,4.4c-0.8,0.4-1.6,0.3-2.2-0.1l0,0
          l1.6,3.2l-0.9,0.4l-3.1-6.4c-0.4-0.8-0.7-1.3-1-1.9l0.8-0.4L26.1,14.2L26.1,14.2z M27.4,16.7c0.6,1.1,1.7,1.3,2.5,0.9
          c1.2-0.6,1.3-1.9,0.6-3.3c-0.6-1.2-1.7-2-2.9-1.4c-1,0.5-1.2,1.8-0.8,2.6L27.4,16.7z"/>
      </g>
      <g>
        <path class="st2" fill="#67B2C1" d="M34.7,29.9l0.3-5.7c3.2-1.7,5.9-3.1,8.1-4.5c1.4-0.8,2.9-1.6,4.3-2.4V18c0,0.3-0.1,1.5-0.4,3.8
          c-0.1,1.2-0.3,3.1-0.4,5.8l-0.3,4.8c-0.3,4.4-0.5,7.1-0.7,8.1c-0.2,0.9-0.7,1.6-1.3,2.1c-0.7,0.5-2.7,1-6.1,1.7
          c0.4-1,0.7-2.5,0.8-4.5l0.2-5.5c0.1-2.5,0.1-4.5,0.1-6c0-0.4,0-0.9,0-1.4l-2.7,1.8C35.6,29.4,35,29.8,34.7,29.9z"/>
      </g>
      <path class="st3" display="none" fill="none" stroke="#69BACA" stroke-miterlimit ="10" d="M65.1,44.5c3.9-4.4,6.1-9.7,6.1-15.5c0-15.1-15.7-27.4-35.1-27.4S1.1,13.8,1.1,29s15.7,27.4,35.1,27.4
        c8.6,0,16.5-2.4,22.6-6.5c0.7,0.2,1.6,0.3,2.5,0.5c8.4,1.8,10.6-3.1,10.6-3.1C68.4,47.4,66.3,45.8,65.1,44.5z"/>
      <g class="st4" display="none">
        <path class="st5" display="inline" fill="#31507A" d="M12.6,18.1c-0.3,0-0.9,0-1.6,0.3C9.8,19,9.8,19.9,10,20.5c0.4,0.8,1.1,1,2.4,0.9c1.6-0.1,2.6,0.3,3.2,1.4
          c0.6,1.3,0.2,2.8-1.6,3.6c-0.7,0.4-1.7,0.5-2.2,0.4L11.7,26c0.6,0.1,1.3,0,2-0.4c1.1-0.5,1.5-1.4,1-2.3c-0.4-0.8-1.1-1.1-2.4-1
          c-1.5,0.1-2.7-0.2-3.2-1.3c-0.6-1.2,0-2.7,1.5-3.4c0.8-0.4,1.5-0.5,1.9-0.4L12.6,18.1z"/>
        <path class="st5" display="inline" fill="#31507A" d="M15,17.2l0.7-0.7l0.7,1.4l1.5-0.7l0.3,0.7l-1.5,0.7l1.7,3.4c0.4,0.7,0.8,1,1.4,0.8c0.3-0.1,0.4-0.3,0.6-0.4
          l0.4,0.7c-0.2,0.2-0.4,0.4-0.8,0.6c-1.4,0.7-2.1-0.6-2.4-1.2L15.8,19l-0.9,0.4l-0.3-0.7l0.9-0.4L15,17.2z"/>
        <path class="st5" display="inline" fill="#31507A" d="M26,20.2c-0.3,0.3-0.8,0.8-1.7,1.3c-1.7,0.8-3.3,0.1-4.2-1.6c-0.9-1.8-0.5-3.7,1.1-4.4
          c1.8-0.9,3.1,0.5,3.6,1.6c0.1,0.2,0.2,0.4,0.2,0.5l-4,2c0.8,1.6,2,1.8,3.1,1.3c0.7-0.4,1.1-0.7,1.4-1.1L26,20.2z M23.8,17.2
          c-0.4-0.8-1.2-1.7-2.4-1.1c-1.1,0.5-1.1,1.8-0.7,2.6L23.8,17.2z"/>
        <path class="st5" display="inline" fill="#31507A" d="M26.2,14.3c0.1-0.9,0.5-1.7,1.5-2.1c1.4-0.7,3,0,3.9,1.8c1.1,2.2,0.3,3.8-1,4.4c-0.8,0.4-1.6,0.3-2.2-0.1l0,0
          l1.6,3.2L28.9,22l-3.1-6.4c-0.4-0.8-0.7-1.3-1-1.9l0.8-0.4L26.2,14.3L26.2,14.3z M27.5,16.8c0.6,1.1,1.7,1.3,2.5,0.9
          c1.2-0.6,1.3-1.9,0.6-3.3c-0.6-1.2-1.7-2-2.9-1.4c-1,0.5-1.2,1.8-0.8,2.6L27.5,16.8z"/>
      </g>
      <g class="st4" display="none">
        <path class="st6" display="inline" fill="#67B2C1" d="M33,25.3l5.5-7.4c0.8-0.1,1.4-0.2,2-0.2c2.4,0,4.4,0.8,6,2.3c1.7,1.5,2.5,3.4,2.5,5.5c0,4-2.4,8-7.3,11.8
          c1.9,0.6,5,0.9,9.1,0.9l-0.7,1.7c-0.7,1.8-1.5,3.1-2.4,3.7c-0.9,0.6-1.8,0.9-2.8,0.9c-0.7,0-2.1-0.2-4-0.6
          c-3.4-0.8-6.2-1.2-8.3-1.4c1.3-1.5,2.2-2.5,2.6-3c1.1-1.2,2.1-2.2,2.9-3.2c0.8-0.9,1.3-1.7,1.7-2.3c0.8-1.4,1.3-2.8,1.3-4.4
          c0-1.5-0.4-2.7-1.3-3.6c-0.9-0.9-2.1-1.3-3.7-1.3C35.1,24.8,34.1,25,33,25.3z"/>
      </g>
      </svg>
    </template>
    <template v-if="name === 'step2'">
      <svg
        version="1.1"
        id="レイヤー_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 72.9 58"
        style="enable-background:new 0 0 72.9 58;"
        xml:space="preserve"
        :width="width"
        :height="height">
      <path class="st0" fill="none" stroke="#69BACA" stroke-miterlimit ="10" d="M65,44.4c3.9-4.4,6.1-9.7,6.1-15.5C71.1,13.7,55.4,1.5,36,1.5S1,13.7,1,28.9S16.7,56.3,36,56.3
        c8.6,0,16.5-2.4,22.6-6.5c0.7,0.2,1.6,0.3,2.5,0.5c8.4,1.8,10.6-3.1,10.6-3.1C68.2,47.3,66.1,45.7,65,44.4z"/>
      <g>
        <path class="st1" fill="#31507A" d="M12.5,18c-0.3,0-0.9,0-1.6,0.3c-1.1,0.6-1.2,1.5-0.9,2.1c0.4,0.8,1.1,1,2.4,0.9c1.6-0.1,2.6,0.3,3.2,1.4
          c0.6,1.3,0.2,2.8-1.6,3.6c-0.7,0.4-1.7,0.5-2.2,0.4l-0.1-0.9c0.6,0.1,1.3,0,2-0.4c1.1-0.5,1.5-1.4,1-2.3c-0.4-0.8-1.1-1.1-2.4-1
          C10.8,22.4,9.6,22,9,20.9c-0.6-1.2,0-2.7,1.5-3.4c0.8-0.4,1.5-0.5,1.9-0.4L12.5,18z"/>
        <path class="st1" fill="#31507A" d="M14.8,17.1l0.7-0.7l0.7,1.4l1.5-0.7l0.3,0.7l-1.5,0.7l1.7,3.4c0.4,0.7,0.8,1,1.4,0.8c0.3-0.1,0.4-0.3,0.6-0.4
          l0.4,0.7c-0.2,0.2-0.4,0.4-0.8,0.6c-1.4,0.7-2.1-0.6-2.4-1.2l-1.6-3.4l-0.9,0.4l-0.3-0.7l0.9-0.4L14.8,17.1z"/>
        <path class="st1" fill="#31507A" d="M25.8,20.1c-0.3,0.3-0.8,0.8-1.7,1.3c-1.7,0.8-3.3,0.1-4.2-1.6c-0.9-1.8-0.5-3.7,1.1-4.4
          c1.8-0.9,3.1,0.6,3.6,1.6c0.1,0.2,0.2,0.4,0.2,0.5l-4,2c0.8,1.6,2,1.8,3.1,1.3c0.7-0.4,1.1-0.7,1.4-1.1L25.8,20.1z M23.7,17.1
          c-0.4-0.8-1.2-1.7-2.4-1.1c-1.1,0.5-1.1,1.8-0.7,2.6L23.7,17.1z"/>
        <path class="st1" fill="#31507A" d="M26,14.2c0.1-0.9,0.5-1.7,1.5-2.1c1.4-0.7,3,0,3.9,1.8c1.1,2.2,0.3,3.8-1,4.4c-0.8,0.4-1.6,0.3-2.2-0.1l0,0
          l1.6,3.2l-0.9,0.4l-3.1-6.4c-0.4-0.8-0.7-1.3-1-1.9l0.8-0.4L26,14.2L26,14.2z M27.3,16.7c0.6,1.1,1.7,1.3,2.5,0.9
          c1.2-0.6,1.3-1.9,0.6-3.3c-0.6-1.2-1.7-2-2.9-1.4c-1,0.5-1.2,1.8-0.8,2.6L27.3,16.7z"/>
      </g>
      <g>
        <path class="st7" fill="#69BACA" d="M32.9,25.2l5.5-7.4c0.8-0.1,1.4-0.2,2-0.2c2.4,0,4.4,0.8,6,2.3c1.7,1.5,2.5,3.4,2.5,5.5c0,4-2.4,8-7.3,11.8
          c1.9,0.6,5,0.9,9.1,0.9L50,39.8c-0.7,1.8-1.5,3.1-2.4,3.7c-0.9,0.6-1.8,0.9-2.8,0.9c-0.7,0-2.1-0.2-4-0.6c-3.4-0.8-6.2-1.2-8.3-1.4
          c1.3-1.5,2.2-2.5,2.6-3c1.1-1.2,2.1-2.2,2.9-3.2c0.8-0.9,1.3-1.7,1.7-2.3c0.8-1.4,1.3-2.8,1.3-4.4c0-1.5-0.4-2.7-1.3-3.6
          c-0.9-0.9-2.1-1.3-3.7-1.3C35,24.7,34,24.9,32.9,25.2z"/>
      </g>
      </svg>
    </template>
    <template v-if="name === 'step3'">
      <svg
        version="1.1"
        id="レイヤー_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 72.9 58"
        style="enable-background:new 0 0 72.9 58;"
        xml:space="preserve"
        :width="width"
        :height="height">
      <path class="st0" fill="none" stroke="#69BACA" stroke-miterlimit ="10" d="M64.9,44.3c3.9-4.4,6.1-9.7,6.1-15.5C71,13.6,55.3,1.4,35.9,1.4S0.9,13.6,0.9,28.8s15.7,27.4,35.1,27.4
        c8.6,0,16.5-2.4,22.6-6.5c0.7,0.2,1.6,0.3,2.5,0.5c8.4,1.8,10.6-3.1,10.6-3.1C68.1,47.2,66,45.6,64.9,44.3z"/>
      <g>
        <path class="st1" fill="#31507A" d="M12.4,17.9c-0.3,0-0.9,0-1.6,0.3c-1.1,0.6-1.2,1.5-0.9,2.1c0.4,0.8,1.1,1,2.4,0.9c1.6-0.1,2.6,0.3,3.2,1.4
          c0.6,1.3,0.2,2.8-1.6,3.6c-0.7,0.4-1.7,0.5-2.2,0.4l-0.1-0.9c0.6,0.1,1.3,0,2-0.4c1.1-0.5,1.5-1.4,1-2.3c-0.4-0.8-1.1-1.1-2.4-1
          c-1.5,0.1-2.7-0.2-3.2-1.3c-0.6-1.2,0-2.7,1.5-3.4c0.8-0.4,1.5-0.5,1.9-0.4L12.4,17.9z"/>
        <path class="st1" fill="#31507A" d="M14.7,17l0.7-0.7l0.7,1.4l1.5-0.7l0.3,0.7l-1.5,0.7l1.7,3.4c0.4,0.7,0.8,1,1.4,0.8c0.3-0.1,0.4-0.3,0.6-0.4
          l0.4,0.7c-0.2,0.2-0.4,0.4-0.8,0.6c-1.4,0.7-2.1-0.6-2.4-1.2l-1.6-3.4l-0.9,0.4l-0.3-0.7l0.9-0.4L14.7,17z"/>
        <path class="st1" fill="#31507A" d="M25.7,20c-0.3,0.3-0.8,0.8-1.7,1.3c-1.7,0.8-3.3,0.1-4.2-1.6c-0.9-1.8-0.5-3.7,1.1-4.4
          c1.8-0.9,3.1,0.5,3.6,1.6c0.1,0.2,0.2,0.4,0.2,0.5l-4,2c0.8,1.6,2,1.8,3.1,1.3c0.7-0.4,1.1-0.7,1.4-1.1L25.7,20z M23.6,17
          c-0.4-0.8-1.2-1.7-2.4-1.1c-1.1,0.5-1.1,1.8-0.7,2.6L23.6,17z"/>
        <path class="st1" fill="#31507A" d="M25.9,14.1c0.1-0.9,0.5-1.7,1.5-2.1c1.4-0.7,3,0,3.9,1.8c1.1,2.2,0.3,3.8-1,4.4c-0.8,0.4-1.6,0.3-2.2-0.1l0,0
          l1.6,3.2l-0.9,0.4l-3.1-6.4c-0.4-0.8-0.7-1.3-1-1.9l0.8-0.4L25.9,14.1L25.9,14.1z M27.2,16.6c0.6,1.1,1.7,1.3,2.5,0.9
          c1.2-0.6,1.3-1.9,0.6-3.3c-0.6-1.2-1.7-2-2.9-1.4c-1,0.5-1.2,1.8-0.8,2.6L27.2,16.6z"/>
      </g>
      <g>
        <path class="st7" fill="#69BACA" d="M34.9,17.9c1.6-0.2,3.5-0.3,5.6-0.3c1.2,0,2.3,0,3.2,0.1c1.4,0.1,2.4,0.1,2.8,0.1c0.6,0,1.6,0,2.8-0.1L42,30.2
          c2.6,0.3,4.5,0.6,5.6,0.9c0.5,1.1,0.8,2.5,0.8,4.2c0,3.4-0.9,6.1-2.7,7.8c-1.8,1.8-3.9,2.7-6.5,2.7c-2,0-4.2-0.3-6.6-0.9v-0.1
          c3.2-0.3,5.3-1,6.4-2c1.1-1,1.6-2.3,1.6-3.9c0-2.6-1.8-4-5.3-4c0.3-0.5,0.7-1.1,1.2-1.8c2-2.4,3.7-5.2,5-8.5c-1-0.1-2-0.1-3.1-0.1
          c-0.8,0-1.6,0-2.4,0.1c-1.1,0-1.9,0.1-2.1,0.1c-0.1,0-0.4,0-1,0C33.9,21.5,34.6,19.3,34.9,17.9z"/>
      </g>
      </svg>
    </template>
  </span>
</template>

<script>
export default {
  name: 'SHIcons',
  props: {
    name: {
      type: String,
      default: 'bell'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: '#33537E'
    },
    strokeColor: {
      type: String,
      default: '#33537E'
    },
    strokeWidth: {
      type: [Number, String],
      default: 0
    }
  },
  computed: {
    styleObject: function () {
      return {
        fill: this.iconColor,
        stroke: this.strokeColor,
        'stroke-width': this.strokeWidth
      }
    }
  }
}
</script>
